import {throwError as observableThrowError} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class MainMenuService {
    constructor(private http: HttpClient) {
    }

    public getData(userid: Object) {
        let URL = 'assets/data/main-menu.json';
        let access=userid["custom:access"].toLowerCase()
        if (access === 'su'|| access === 'ga') {
           URL = 'assets/data/admin-main-menu.json';
        }
        else if(access === 'qa'){
         URL = 'assets/data/QA-menu.json';
        }
        else
        {
         URL = 'assets/data/main-menu.json';
        }
        return this.http.get(URL);
    }

    public handleError(error: any) {
        return observableThrowError(error.error || 'Server Error');
    }
}
